import { auth, noAuth } from "..";

// ====== Event Category Section ======
export const getAllEventCategory = async () => {
    const res = await auth({
        method: "GET",
        url:'/admin/events/categories',
    });
    return res;
}
export const createCategory = async (data) => {
    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage?.getItem("adminSession") || ""}`,
        }
    }
    const res = await auth({
        method: "POST",
        url: "/admin/events/category",
        data,
        options
    });
    return res;
}
export const updateCategory = async (id, data) => {
    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage?.getItem("adminSession") || ""}`,
        }
    }
    const res = await auth({
        method: "PUT",
        url: `/admin/events/category/${id}`,
        data,
        options,
    });
    return res;
}

// ====== Event Tags Section ======
export const getAllEventTags = async () => {
    const res = await auth({
        method: "GET",
        url:'/admin/events/tags',
    });
    return res;
}
export const getAllActiveEventTags = async () => {
    const res = await auth({
        method: "GET",
        url:'/admin/events/tags',
    });
    return res;
}
export const createTags = async (data) => {
    const res = await auth({
        method: "POST",
        url: "/admin/events/tags",
        data,
    });
    return res;
}
export const updateTags = async (id, data) => {
    const res = await auth({
        method: "PUT",
        url: `/admin/events/tags/${id}`,
        data,
    });
    return res;
}

// ====== Event Hosts Section ======
export const getAllHosts = async () => {
    const res = await auth({
        method: "GET",
        url:'/admin/events/hosts',
    });
    return res;
}
export const getHostById = async (id) => {
    const res = await noAuth({
        method: "GET",
        url: `/hosts/community/${id}`,
    });
    return res;
}
export const getHostDetailsById = async (id) => {
    const res = await auth({
        method: "GET",
        url: `/host/${id}`,
    });
    return res;
}
export const getHostGallery = async (id, page = 1, limit = 10) => {
    const res = await auth({
        method: "GET",
        url: `/admin/hosts/${id}/gallery?page=${page}&limit=${limit}`,
    });
    return res;
}
export const getHostReviews = async (id, page = 1, limit = 10) => {
    const res = await auth({
        method: "GET",
        url: `/admin/events/auth/reviews/${id}?page=${page}&limit=${limit}`,
    });
    return res;
}
export const getHostEventHistory = async (id, type = 'published', page = 1, limit = 10) => {
    const res = await auth({
        method: "GET",
        url: `/admin/events/auth/host/${id}/history?type=${type}&page=${page}&limit=${limit}`,
    });
    return res;
}
export const createHost = async (data) => {
    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage?.getItem("adminSession") || ""}`,
        }
    }
    const res = await auth({
        method: "POST",
        url: "/admin/events/host",
        data,
        options
    });
    return res;
}
export const updateHost = async (id, data) => {
    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage?.getItem("adminSession") || ""}`,
        }
    }
    const res = await auth({
        method: "PUT",
        url: `/admin/events/host/${id}`,
        data,
        options,
    });
    return res;
}

// ====== Event Location Section ======
export const getCountries = async () => auth({ method: "GET", url: "/admin/locations/countries" });
export const getLocationCounts = async () => auth({ method: "GET", url: "/admin/locations/counts" });
export const getCities = async (country) => auth({ method: "GET", url: `/admin/locations/cities${country ? `?country=${country}` : ""}` });
export const createCountry = async (data) => auth({ method: "POST", url: "/admin/locations/countries", data });
export const updateCountry = async (id, data) => auth({ method: "PUT", url: `/admin/locations/countries/${id}`, data });
export const createCity = async (data) => auth({ method: "POST", url: "/admin/locations/cities", data });
export const updateCity = async (id, data) => auth({ method: "PUT", url: `/admin/locations/cities/${id}`, data });
export const getStates = async (country) => auth({ method: "GET", url: `/admin/locations/states${country ? `?country=${country}` : ""}` });
export const createState = async (data) => auth({ method: "POST", url: "/admin/locations/states", data });
export const updateState = async (id, data) => auth({ method: "PUT", url: `/admin/locations/states/${id}`, data });
export const getAllActiveLocation = async () => {
    const res = await auth({
        method: "GET",
        url:'/events/locations',  // /admin/events/locations
    });
    return res;
}
export const getAllLocation = async () => {
    const res = await auth({
        method: "GET",
        url:'/admin/events/locations',
    });
    return res;
}
export const createLocation = async (data) => {
    const res = await auth({
        method: "POST",
        url: "/admin/events/locations",
        data,
    });
    return res;
}
export const updateLocation = async (id, data) => {
    const res = await auth({
        method: "PUT",
        url: `/admin/events/locations/${id}`,
        data,
    });
    return res;
}

// ====== Event Section ======
//  ==== GET ====
export const getAllEvents = async (page,status = 'published') => {
    const res = await auth({
        method: "GET",
        url:`/admin/events?page=${page}&limit=10&status=${status}`,
    });
    return res;
}

export const getUnAuthEventBySlug = async (slug) => {
    const res = await noAuth({
        method: 'GET',
        url: `/events/slug/${slug}`
    });
    return res;
}
export const getEventById = async (id) => {
    const res = await auth({
        method: "GET",
        url:`/admin/events/${id}`,
    });
    return res;
}
export const getEventParticipantsById = async (id,page) => {
    const res = await auth({
        method: "GET",
        url:`/admin/events/participants/${id}?page=${page}&limit=10`,
    });
    return res;
}
export const getEventConfirmedParticipantsById = async (id, page) => {
    const res = await auth({
        method: "GET",
        url:`/admin/events/participants/confirmed/${id}?page=${page}&limit=10`,
    });
    return res;
}
export const getPreBookedParticipantsById = async (id, page) => {
    const res = await auth({
        method: "GET",
        url:`/admin/events/prebookings/${id}?page=${page}&limit=10`,
    });
    return res;
}

export const getRequestedParticipantsById = async (id, page) => {
    const res = await auth({
        method: "GET",
        url:`/admin/events/requested/${id}?page=${page}&limit=10`,
    });
    return res;
}

export const getAcceptedParticipantsById = async (id, page) => {
    const res = await auth({
        method: "GET",
        url:`/admin/events/accepted/${id}?page=${page}&limit=10`,
    });
    return res;
}

export const getRejectedParticipantsById = async (id, page) => {
    const res = await auth({
        method: "GET",
        url:`/admin/events/rejected/${id}?page=${page}&limit=10`,
    });
    return res;
}

export const getEventCancelledParticipantsById = async (id, page) => {
    const res = await auth({
        method: "GET",
        url:`/admin/events/cancelled/${id}?page=${page}&limit=10`,
    });
    return res;
}

// ==== POST ====
export const createNewEvent = async (data) => {
    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage?.getItem("adminSession") || ""}`,
        }
    }
    const res = await auth({
        method: "POST",
        url: '/admin/events',
        data,
        options,
    });
    return res;
}

export const duplicateEventById = async (id) => {
    const res = await auth({
        method: "POST",
        url:`/admin/events/duplicate/${id}`,
    });
    return res;
}
// ==== DELETE ====
export const deleteEventById = async (id) => {
    const res = await auth({
        method: "DELETE",
        url:`/admin/events/${id}`,
    });
    return res;
}
// ==== PUT ====
export const enableEventConnection = async (id) => {
    const res = await auth({
        method: "PUT",
        url:`/admin/events/connection/${id}`,
    });
    return res;
}

export const editEvent = async (id, data) => {
    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage?.getItem("adminSession") || ""}`,
        }
    }
    const res = await auth({
        method: "PUT",
        url: `/admin/events/${id}`,
        data,
        options,
    });
    return res;
}
export const updateEventParticipantStatus = async (data, status) => {
    const res = await auth({
        method: "PUT",
        url: `/admin/events/participant?status=${status}`,
        data,
    });
    return res;
}

// Event Comment Management
export const getEventsCommentsByEventId = async (id,page) => {
    const res = await auth({
        method: "GET",
        url: `/admin/events/comments/${id}?page=${page}&limit=10`,
    });
    return res;
}

export const updateEventsCommentStatus = async (id, status) => {
    const res = await auth({
        method: "PUT",
        url: `/admin/events/comment/status/${id}?status=${status}`,
    });
    return res;
}

// SLUG
export const getSlug = async (data) => {
    const res = await auth({
        method: "POST",
        url: `/admin/events/slug`,
        data,
    });
    return res;
}


// Event Table updation
export const updateEventOnlineLink = async (id,data) => {
    const res = await auth({
        method: "PUT",
        url: `/admin/events/link/${id}`,
        data
    });
    return res;
}

export const updateEventStatus = async (id,status) => {
    const res = await auth({
        method: "PUT",
        url: `/admin/events/status/${id}?status=${status}`,
    });
    return res;
}

export const cancelEventParticipant = async (id,data) => {
    const res = await auth({
        method: "PUT",
        url: `/admin/event/participant/cancel/${id}`,
        data
    });
    return res;
}

export const sendNotificationToParticipants = async (data) => {
    const res = await auth({
        method: "POST",
        url: `/notifications/event`,
        data
    });
    return res;
}

export const getEligibleEventParticipants = async (id,page) => {
    const res = await auth({
        method: "GET",
        url: `/admin/events/eligible/${id}?page=${page}&limit=10`,
    });
    return res;
}

export const getEventActivity = async ( page) => {
    const res = await auth({
      method: "GET",
      url: `/admin/events/activity?page=${page}&limit=10`,
    });
    return res
  }

